<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="closeModal"
    title="Add Goal"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="goalForm">
        <v-row class="mt-2">
          <v-col cols="12" md="6">
            <v-text-field
              label="Goal Name"
              v-model="name"
              validate-on-blur
              :rules="[required('Goal Name')]"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <SimpleDatePicker
              :label="`Target Date`"
              :value="targetDate"
              :isRequired="true"
              :minDateEnable="true"
              :maxDateEnable="true"
              @selected-date-change="handleTargetDateChange"
            ></SimpleDatePicker>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="handleSaveTodoGoal"
          >
            Add
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import { mapActions } from 'vuex'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { SimplePageHeader } from '@/components/pageComponents'
import { DynamicModal } from '@/components/dialogs'
import { required } from '@/lib/formValidations'

export default {
  components: {
    SimpleDatePicker,
    SimplePageHeader,
    DynamicModal
  },
  data () {
    return {
      showModalProp: false,
      name: null,
      targetDate: null
    }
  },
  methods: {
    ...mapActions('todoGroup', [
      'saveTodoGroup'
    ]),
    handleTargetDateChange (value) {
      this.targetDate = value
    },
    handleSaveTodoGoal () {
      if (this.$refs.goalForm.validate()) {
        this.saveTodoGroup(
          {
            name: this.name,
            targetDate: this.targetDate
          }
        )
          .then((result) => {
            this.$emit('todoGoalCreated', result.id, result.targetDate)
            this.closeModal()
          })
      }
    },
    showModal () {
      this.showModalProp = true
    },
    closeModal () {
      this.clearNewTodoGoal()
      this.$refs.goalForm.resetValidation()
      this.showModalProp = false
    },
    clearNewTodoGoal () {
      this.name = null
      this.targetDate = null
    },
    required
  },
  beforeMount () {
    this.clearNewTodoGoal()
  }
}
</script>
